import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import structureAxios from '../../axios/structure'
import { fetchStageOptions } from './dropdownOptions'

export const fetchStructure = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchStructureStart())
    structureAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchStructureSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchStructureFailed(error))
      })
  }
}

export const fetchStructureStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_START
  }
}

export const fetchStructureSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_STRUCTURE_SUCCESS,
    pagination,
    records
  }
}

export const fetchStructureFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FAILED,
    errorMessage
  }
}

export const fetchStructureById = recordId => {
  return dispatch => {
    dispatch(fetchStructureStart())
    structureAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStructureByIdSuccess(response.data.data))
          dispatch(fetchTargetScoreOptions(response.data.data?.structure_type.value_list_code))
          dispatch(
            fetchStageOptions({
              company_id: response.data.data?.company_id,
              structure_type_id: response.data.data?.structure_type_id
            })
          )
        }
      })
      .catch(error => {
        dispatch(fetchStructureFailed(error))
      })
  }
}

export const fetchStructureByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_STRUCTURE_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedStructureRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_STRUCTURE_RECORD
  }
}

export const createStructure = (recordData, page) => {
  return dispatch => {
    dispatch(createStructureStart())

    structureAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Structure Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createStructureSuccess())
          dispatch(fetchStructure(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Structure field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createStructureFailed())
      })
  }
}

export const createStructureStart = () => {
  return {
    type: actionTypes.CREATE_STRUCTURE_START
  }
}

export const createStructureSuccess = () => {
  return {
    type: actionTypes.CREATE_STRUCTURE_SUCCESS
  }
}

export const createStructureFailed = () => {
  return {
    type: actionTypes.CREATE_STRUCTURE_FAILED
  }
}

export const updateStructure = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateStructureStart())
    structureAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Structure Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateStructureSuccess())
        dispatch(fetchStructure(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Structure field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateStructureFailed())
      })
  }
}

export const updateStructureStart = () => {
  return {
    type: actionTypes.UPDATE_STRUCTURE_START
  }
}

export const updateStructureSuccess = () => {
  return {
    type: actionTypes.UPDATE_STRUCTURE_SUCCESS
  }
}

export const updateStructureFailed = () => {
  return {
    type: actionTypes.UPDATE_STRUCTURE_FAILED
  }
}

export const deleteStructure = (recordId, page) => {
  return dispatch => {
    dispatch(deleteStructureStart())
    structureAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Structure Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteStructureSuccess())
        dispatch(fetchStructure(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteStructureFailed())
      })
  }
}

export const deleteStructureStart = () => {
  return {
    type: actionTypes.DELETE_STRUCTURE_START
  }
}

export const deleteStructureSuccess = () => {
  return {
    type: actionTypes.DELETE_STRUCTURE_SUCCESS
  }
}

export const deleteStructureFailed = () => {
  return {
    type: actionTypes.DELETE_STRUCTURE_FAILED
  }
}

export const fetchTargetScoreOptions = recordsId => {
  let params = {
    value_list_code: recordsId
  }
  return dispatch => {
    dispatch(fetchTargetScoreOptionsStart())
    structureAxios
      .get('/target_score/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchTargetScoreOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchTargetScoreOptionsFailed(error?.response?.data?.message))
      })
  }
}

export const fetchTargetScoreOptionsStart = () => {
  return {
    type: actionTypes.FETCH_TARGET_SCORE_OPTIONS_START
  }
}

export const fetchTargetScoreOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_TARGET_SCORE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchTargetScoreOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_TARGET_SCORE_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchStructureFilterStructure = filter => {
  return dispatch => {
    dispatch(fetchStructureFilterStructureStart())
    structureAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStructureFilterStructureSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchStructureFilterStructureFailed(error?.response?.data?.message))
      })
  }
}

export const fetchStructureFilterStructureStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_START
  }
}

export const fetchStructureFilterStructureSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_SUCCESS,
    data
  }
}

export const fetchStructureFilterStructureFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_FAILED,
    errorMessage
  }
}

export const fetchStructureFilterStructureType = filter => {
  return dispatch => {
    dispatch(fetchStructureFilterStructureTypeStart())
    structureAxios
      .get('/structure_type/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStructureFilterStructureTypeSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchStructureFilterStructureTypeFailed(error?.response?.data?.message))
      })
  }
}

export const fetchStructureFilterStructureTypeStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_START
  }
}

export const fetchStructureFilterStructureTypeSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_SUCCESS,
    data
  }
}

export const fetchStructureFilterStructureTypeFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_FAILED,
    errorMessage
  }
}

export const fetchStructureFilterActive = () => {
  return dispatch => {
    dispatch(fetchStructureFilterActiveStart())
    let active = [
      {
        active_id: 1,
        active_code: 1,
        active_name: 'Active'
      },
      {
        active_id: 0,
        active_code: 0,
        active_name: 'Inactive'
      }
    ]

    if (active) {
      dispatch(fetchStructureFilterActiveSuccess(active))
    } else {
      dispatch(fetchStructureFilterActiveFailed('Get active fail'))
    }
  }
}

export const fetchStructureFilterActiveStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_ACTIVE_START
  }
}

export const fetchStructureFilterActiveSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_ACTIVE_SUCCESS,
    data
  }
}

export const fetchStructureFilterActiveFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_FILTER_ACTIVE_FAILED,
    errorMessage
  }
}

// const fetchStageOptions = filterOptions => {
//   let params = null
//   if (filterOptions) {
//     params = filterOptions
//   }
//   return dispatch => {
//     dispatch(fetchStageOptionsStart())
//     structureAxios
//       .get('stage/dropdown', { params })
//       .then(response => {
//         if (response.status === 200) {
//           dispatch(fetchStageOptionsSuccess(response.data.data))
//         }
//       })
//       .catch(error => {
//         dispatch(fetchStageOptionsFailed(error))
//       })
//   }
// }

// const fetchStageOptionsStart = () => {
//   return {
//     type: actionTypes.FETCH_STAGE_OPTIONS_START
//   }
// }

// const fetchStageOptionsSuccess = data => {
//   return {
//     type: actionTypes.FETCH_STAGE_OPTIONS_SUCCESS,
//     data
//   }
// }

// const fetchStageOptionsFailed = errorMessage => {
//   return {
//     type: actionTypes.FETCH_STAGE_OPTIONS_FAILED,
//     errorMessage
//   }
// }
